﻿import { FIQAssist } from "../app";
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils"
import { IComponent, Component, Attribute, Input, Output, Inject } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'datatable',
    templateUrl: "views/datatable.html"
})
export class DataTable implements IComponent {
    private _columns: TableColumn[];
    private _data: TableRow[];
    private hovered: TableRow;
    private headerHovered: TableColumn;
    private initialized: boolean = false;
    private _contentscroller: Element;

    constructor(
        @Inject('$sce') private $sce: ng.ISCEService,
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$timeout') private $timeout: angular.ITimeoutService) {
    }

    public $onInit() {
        this.UpdateColumnDisplay();
        this._contentscroller = this.$element[0].getElementsByClassName('dataTableContent').item(0);
        this.initialized = true;
    }

    public $onDestroy() {
    }

    @Input() public noresultText;

    private _sortcolumn: string;
    @Input()
    get sortcolumn(): string {
        return this._sortcolumn;
    }
    set sortcolumn(val: string) {
        this._sortcolumn = val;
        if (this.initialized && val != this._sortcolumn) {
            this.UpdateColumnDisplay();
        }
    }

    private _sortdescending: boolean;
    @Input()
    get sortdescending(): boolean {
        return this._sortdescending;
    }
    set sortdescending(val: boolean) {
        this._sortdescending = val;
        if (this.initialized && val != this._sortdescending) {
            this.UpdateColumnDisplay();
        }
    }

    @Input() public storeid: string;

    @Input()
    get columns(): TableColumn[] { return this._columns; }
    set columns(cols: TableColumn[]) {
        this._columns = cols;
        if (this.initialized && cols) {
            this.UpdateColumnDisplay();
        }
    }

    @Input()
    get data(): TableRow[] { return this._data }
    set data(data: TableRow[]) {
        this._data = data;
        if (this.initialized && data) {
            this.ondataresize({ count: data.length });
        }
    }

    @Input() public fillactionText: string;
    @Output() public fillaction: (args: {}) => void;
    public fillactionPass() {
        if (this.fillaction && this.fillactionText) this.fillaction({});
    };
    @Output() public oncolumnclicked: (args: { source: TableColumn, column: number, descending: boolean }) => void;
    @Output() public onrowclicked: (args: { source: TableRow, rowid: any, ctrlkey: boolean }) => void;
    @Output() public onrowdoubleclicked: (args: { source: TableRow, rowid: any }) => void;
    @Output() public oncellclicked: (args: { source: TableCell, rowid: any, column: number }) => void;
    @Output() public onsortdata: (args: { source: TableColumn, column: number, descending: boolean }) => void;
    @Output() public onrowsdelete: (args: { sources: TableRow[] }) => void;
    @Output() public ondataresize: (args: { count: number }) => void;

    public onRowClick(event: MouseEvent, row: TableRow, index: number) {
        if (event.button === 0) {
            event.preventDefault();
            if (!event.ctrlKey && !event.shiftKey)
                this.data.filter(r => r != row).forEach(x => x.selected = false);

            if (!row.selected && event.shiftKey) {
                var first = this.data.filter(r => r.selected).shift();
                if (first) {
                    var fi = this.data.indexOf(first);
                    var ci = this.data.indexOf(row);
                    this.data.forEach((r, i) => r.selected = fi < ci ? i >= fi && i <= ci : i >= ci && i <= fi);
                } else {
                    row.selected = !row.selected;
                }
            } else {
                row.selected = !row.selected;
            }
            this.onrowclicked({ source: row, rowid: row.id, ctrlkey: event.ctrlKey || event.metaKey });
        }
    }

    private sortingdone: boolean = false;

    @Input()
    public showtextnoresults: boolean;

    private initialSort() {

    }

    public onRowDoubleClick(event: Event, row: TableRow, index: number) {
        this.data.forEach(x => x.selected = false);
        row.selected = true;
        angular.element(<any>event.currentTarget).addClass('selected');
        this.onrowdoubleclicked({ source: row, rowid: row.id });
    }

    public onCellClick(event: MouseEvent, cell: TableCell, row: TableRow, index: number) {
        this.oncellclicked({ source: cell, rowid: row.id, column: index });
    }

    public doSort(column: TableColumn, index: number, descending: boolean) {
        if (column.isSortable) {
            this.columns.forEach(x => { x.isSortedAscending = x.isSortedDescending = false; });
            if (descending)
                column.isSortedDescending = true;
            else
                column.isSortedAscending = true;
            this.hovered = null;
            this.onsortdata({ source: column, column: index, descending: descending });
        }
    }

    private UpdateColumnDisplay() {
        if (this._columns && this._sortcolumn && this._sortdescending !== undefined) {
            var column = this.columns.filter(x => x.key == this._sortcolumn).shift();
            if (column && column.isSortable) {
                this.headerHovered = column;
                column.ishovered = true;
                this.columns.forEach(x => { x.isSortedAscending = x.isSortedDescending = false; });
                if (this._sortdescending)
                    column.isSortedDescending = true;
                else
                    column.isSortedAscending = true;
            }
        }
    }

    public onColumnClick(event: Event, column: TableColumn, index: number) {
        event.preventDefault();
        if (this.headerHovered)
            this.headerHovered.ishovered = false;
        if (this.headerHovered != column) {
            this.columns.forEach(x => x.isSortedAscending = x.isSortedDescending = false);
            this.headerHovered = column;
        }
        this.headerHovered.ishovered = true;
        this.columnAction(column, index);
    }

    columnAction(column: TableColumn, index, descending: boolean = null) {
        if (column.isSortable) {
            this._sortdescending = (descending !== null) ? descending : this.columns.some(x => x.isSortedAscending);
            this.doSort(column, index, this._sortdescending);
        } else {
            this.oncolumnclicked({ source: column, column: index, descending: descending });
        }
    }

    private contentFocused = false;

    private onFocus() {
        if (!this._data || this._data.length == 0)
            return;

        if (!this.hovered) {
            this.hovered = this._data[0];
        }
        this.contentFocused = true;
        this.hovered.ishovered = true;
    }

    private onBlur() {
        this.contentFocused = false;
        if (this.hovered != null)
            this.hovered.ishovered = false;
    }

    private headerFocused = false;

    private onHeaderFocus() {
        this.headerFocused = true;
    }

    private onHeaderBlur() {
        this.headerFocused = false;
    }

    private onHeaderKey($event: KeyboardEvent) {
        if ($event.keyCode === 0) {
            switch ($event.code) {
                case KeyboardEventCode.leftArrow:
                    $event.preventDefault();
                    this.headerMove(-1);
                    break;

                case KeyboardEventCode.rightArrow:
                    $event.preventDefault();
                    this.headerMove(1);
                    break;
                case KeyboardEventCode.upArrow:
                    $event.preventDefault();
                    this.headerSort(true);
                    break;

                case KeyboardEventCode.downArrow:
                    $event.preventDefault();
                    this.headerSort(false);
                    break;

                case KeyboardEventCode.enter:
                case KeyboardEventCode.space:
                    $event.preventDefault();
                    this.headerSelect();
                    break;

            }
        } else {
            switch ($event.keyCode) {
                case KeyCodes.leftArrow:
                    $event.preventDefault();
                    this.headerMove(-1);
                    break;

                case KeyCodes.rightArrow:
                    $event.preventDefault();
                    this.headerMove(1);
                    break;

                case KeyCodes.upArrow:
                    $event.preventDefault();
                    this.headerSort(true);
                    break;

                case KeyCodes.downArrow:
                    $event.preventDefault();
                    this.headerSort(false);
                    break;

                case KeyCodes.enter:
                case KeyCodes.space:
                    $event.preventDefault();
                    this.headerSelect();
                    break;

            }
        }
    }

    private onKey($event: KeyboardEvent) {
        if ($event.keyCode === 0) {
            switch ($event.code) {
                case KeyboardEventCode.upArrow:
                    $event.preventDefault();
                    this.move(-1);
                    break;

                case KeyboardEventCode.downArrow:
                    $event.preventDefault();
                    this.move(1);
                    break;

                case KeyboardEventCode.enter:
                case KeyboardEventCode.space:
                    $event.preventDefault();
                    this.select($event.ctrlKey);
                    break;

                case KeyboardEventCode.delete:
                    this.delete();
                    break;
                case KeyboardEventCode.a:
                    if ($event.ctrlKey) {
                        $event.preventDefault();
                        this.data.forEach(r => r.selected == true);
                    }
                    break;
            }

        } else {
            switch ($event.keyCode) {
                case KeyCodes.upArrow:
                    $event.preventDefault();
                    this.move(-1);
                    break;

                case KeyCodes.downArrow:
                    $event.preventDefault();
                    this.move(1);
                    break;

                case KeyCodes.enter:
                case KeyCodes.space:
                    $event.preventDefault();
                    this.select($event.ctrlKey);
                    break;

                case KeyCodes.delete:
                    this.delete();
                    break;
                case KeyCodes.a:
                    if ($event.ctrlKey) {
                        $event.preventDefault();
                        this.data.forEach(r => r.selected == true);
                    }
                    break;
            }
        }
    }

    private headerMove(direction: number) {
        if (this._columns && this.headerHovered) {
            var index = this.columns.map(x => x.text).indexOf(this.headerHovered.text);
            if (this._columns.length > 0) {
                var newindex = Math.max(0, Math.min(this._columns.length - 1, index + direction));
                if (this.headerHovered != null) this.headerHovered.ishovered = false;
                this.headerHovered = this._columns[newindex];
                this.headerHovered.ishovered = true;
            }
        }
    }
    private move(direction: number) {
        if (this._data.length > 0) {
            var newindex = Math.max(0, Math.min(this._data.length - 1, this._data.indexOf(this.hovered) + direction));
            if (this.hovered != null)
                this.hovered.ishovered = false;
            this.hovered = this._data[newindex];
            this.hovered.ishovered = true;
            this.scrollToViewAsync();
        }
    }

    private headerSort(descending: boolean) {
        if (this.headerHovered) {
            var index = this.columns.map(x => x.text).indexOf(this.headerHovered.text);
            this.columnAction(this.headerHovered, index, descending);
        }
    }

    private headerSelect() {
        if (this.headerHovered) {
            var index = this.columns.map(x => x.text).indexOf(this.headerHovered.text);
            this.columnAction(this.headerHovered, index);
        }
    }

    private select(withCtrl: boolean) {
        if (this.hovered) {
            this.hovered.selected = !this.hovered.selected;
            this.onrowclicked({ source: this.hovered, rowid: this.hovered.id, ctrlkey: withCtrl });
        }
    }

    // delete key applies to all selected rows.
    private delete() {
        this.onrowsdelete({ sources: this._data.filter(x => x.selected) });
    }

    private async scrollToViewAsync() {
        var parent = this._contentscroller;
        await this.$timeout()
        var s: any = parent.getElementsByClassName('hovered').item(0);
        if (s)
            parent.scrollTop = Math.max(0, s.offsetTop - ((parent.clientHeight - s.clientHeight) / 2));

    }
}

export class TableColumn {
    constructor(
        public key: string,
        public text: string,
        public isSortable: boolean = false,
        public translate: boolean = false,
        public isSortedAscending: boolean = false,
        public isSortedDescending: boolean = false
    ) {
    }
    public ishovered: boolean;
}

export class TableRow {
    constructor(
        public id: any,
        public cells: TableCell[]
    ) {
        this.selected = false;
        this.ishovered = false;
    }
    public selected: boolean;
    public ishovered: boolean;
    public link?: any[];
}

export class TableCell {
    constructor(
        public content: any,
        public translate: boolean = false,
        public style = () => ""
    ) {
    }
}
